import { getIndexedDBKey } from 'modules/get-indexedDB-key/get-indexedDB-key';

export async function getTerminalId() {
  return (
    (await getIndexedDBKey('terminal-id', 'dropshipments', 'configuration'))
      ?.value || ''
  );
}
